<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-2">Cache do app cliente</h5>
            <p class="text-muted mb-4">
              O app mobile mantém um cache local de 30 minutos para conteúdos estáveis
              (palestrantes, programação, patrocinadores, FAQ, vídeos, arquivos, etc.).
              Use esta página para forçar a atualização imediata em todos os clientes
              após uma mudança de última hora.
            </p>

            <div class="form-group mb-3">
              <label for="resource">Recurso</label>
              <select id="resource" v-model="resource" class="form-control">
                <option value="">Tudo (invalidar todos os recursos)</option>
                <option value="speakers">Palestrantes</option>
                <option value="schedules">Programação</option>
                <option value="sponsors">Patrocinadores</option>
                <option value="faqs">FAQ</option>
                <option value="videos">Vídeos</option>
                <option value="files">Arquivos</option>
                <option value="rooms">Salas</option>
                <option value="dates">Datas</option>
                <option value="interests">Networking (interesses)</option>
                <option value="favorites">Favoritos</option>
              </select>
              <small class="form-text text-muted">
                Selecione um recurso específico ou "Tudo" para invalidar todo o cache.
              </small>
            </div>

            <div class="d-flex align-items-center justify-content-between mt-4">
              <div>
                <small class="text-muted d-block">Versão atual do cache:</small>
                <strong>{{ cacheVersion || '—' }}</strong>
              </div>

              <button
                type="button"
                class="btn btn-primary btn-lg"
                :disabled="loading"
                @click="confirmInvalidate()">
                <i class="bx bx-refresh font-size-16 align-middle mr-1"></i>
                {{ loading ? 'Atualizando...' : 'Atualizar cache do app' }}
              </button>
            </div>

            <hr class="my-4" />

            <p class="text-muted small mb-0">
              <strong>O que acontece ao clicar:</strong><br />
              1. O servidor incrementa <code>cache_version</code> — clientes que abrirem o app depois detectam a mudança via <code>/settings</code> e limpam o cache automaticamente.<br />
              2. Um push silencioso é disparado para todos os usuários online — quem está com o app aberto recebe a invalidação imediatamente.<br />
              3. O cache do servidor (<code>Cache::remember</code>) também é limpo, garantindo dados frescos no próximo fetch.
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import service from './services'

export default {
  components: {
    Layout,
    PageHeader
  },
  name: 'cache',
  page: {
    title: 'Cache do App',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      resource: '',
      cacheVersion: '',
      loading: false,
      title: 'Cache do App',
      items: [
        { text: 'Meu Evento', href: '/' },
        { text: 'Cache do App', active: true }
      ]
    }
  },
  mounted () {
    this.loadVersion()
  },
  methods: {
    async loadVersion () {
      try {
        const res = await service.getCacheVersion()
        this.cacheVersion = res?.data?.data?.cache_version || res?.data?.cache_version || ''
      } catch (err) {
        // silencioso — não é crítico
      }
    },
    confirmInvalidate () {
      const target = this.resource ? `o recurso "${this.resource}"` : 'TODO o cache'
      if (!window.confirm(`Tem certeza que deseja invalidar ${target} no app mobile?\n\nIsso vai forçar todos os usuários a recarregar os dados.`)) {
        return
      }
      this.invalidate()
    },
    async invalidate () {
      this.loading = true
      try {
        const payload = this.resource ? { resource: this.resource } : {}
        const res = await service.invalidateCache(payload)
        this.cacheVersion = res?.data?.data?.cache_version || this.cacheVersion
        successMessage('Cache invalidado com sucesso. Os usuários receberão a atualização em instantes.', 3000)
      } catch (err) {
        errorMessage('Erro ao invalidar cache: ' + (err?.message || 'Tente novamente'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
